/* Szállítási határidő-kijelző (2026-08-18): variáns-váltás követése + cut-off utáni szöveg-váltás.
   Az adat a snippet inline JSON-jából jön; az elem AJAX-os újrarender után is feléled (observer). */
(function () {
  if (window.__wkSzallit) return;
  window.__wkSzallit = true;

  /* 2026-10-02 (kanadai bolt, user): a szállítási szövegben a {ship_date+N} helyőrző az N-edik munkanap dátuma a bolt
     időzónájában — a hétvégék és a data-szunnapok napjai kimaradnak. A felirat angolul (pl. „Monday, October 5"); ez az a nap,
     amikor a futár (ShipTime) elviszi a csomagot. Helyőrző nélküli szövegen semmit nem változtat. */
  var NAP_MS = 24 * 60 * 60 * 1000;
  var MUNKANAP_KERESES_MAX = 60;
  /* 2026-10-29 user K322: a /fr oldalon quebeci francia dátum („vendredi 30 octobre”), minden más nyelven angol. */
  var DATUM_NYELV = /^fr/i.test(document.documentElement.lang || '') ? 'fr-CA' : 'en-CA';

  function maiNapUtc(tz) {
    try {
      var reszek = new Intl.DateTimeFormat('en-CA', { timeZone: tz, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var m = {};
      reszek.forEach(function (r) { m[r.type] = r.value; });
      return new Date(Date.UTC(Number(m.year), Number(m.month) - 1, Number(m.day), 12));
    } catch (e) {
      var d = new Date();
      return new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate(), 12));
    }
  }

  function munkanapE(d, szunnapok) {
    var hetNapja = d.getUTCDay();
    if (hetNapja === 0 || hetNapja === 6) return false;
    return szunnapok.indexOf(d.toISOString().slice(0, 10)) === -1;
  }

  /* kezdoNap: hány naptári nappal a mai után indul a számolás (0 = ma, 1 = holnap) */
  function nedikMunkanap(tz, n, szunnapok, kezdoNap) {
    var d = new Date(maiNapUtc(tz).getTime() + (kezdoNap || 0) * NAP_MS);
    /* 2026-10-15 user K108 (14:00-s cut-off): {ship_date+0} = ma, ha munkanap — hétvégén és ünnepnapon a következő munkanap */
    if (n === 0 && !munkanapE(d, szunnapok)) n = 1;
    var talalt = 0;
    for (var i = 0; i < MUNKANAP_KERESES_MAX && talalt < n; i++) {
      d = new Date(d.getTime() + NAP_MS);
      if (munkanapE(d, szunnapok)) talalt++;
    }
    return d;
  }

  /* 2026-10-15 user K108 (Kristi: este 8-ig beérkezett rendelést a ShipTime másnap viszi): a {ship_date_next+N} az N-edik
     munkanap a HOLNAPI naptól számolva — a cut-off utáni rendelés holnapinak számít, így péntek és szombat este is hétfő */
  function datumHelyorzok(szoveg, tz, szunnapok) {
    return String(szoveg).replace(/\{ship_date(_next)?\+(\d+)\}/g, function (_, holnaptol, n) {
      var d = nedikMunkanap(tz, Number(n), szunnapok, holnaptol ? 1 : 0);
      return d.toLocaleDateString(DATUM_NYELV, { weekday: 'long', month: 'long', day: 'numeric', timeZone: 'UTC' });
    });
  }
  window.__wkSzallitDatum = datumHelyorzok;


  function helyiOra(tz) {
    try {
      return Number(new Intl.DateTimeFormat('en-GB', { timeZone: tz, hour: '2-digit', hourCycle: 'h23' }).format(new Date()));
    } catch (e) { return new Date().getHours(); }
  }

  function feldolgoz(el) {
    if (el.dataset.kesz === '1') return;
    var adatEl = el.querySelector('[data-wk-szallit-adat]');
    if (!adatEl) return;
    var adat;
    try { adat = JSON.parse(adatEl.textContent); } catch (e) { return; }
    el.dataset.kesz = '1';
    var aktualis = el.dataset.kivalasztott;

    function frissit(vid) {
      aktualis = vid;
      var v = adat.vari[String(vid)];
      var fo = el.querySelector('.wk-szallit__fo');
      var sz = el.querySelector('.wk-szallit__szoveg');
      var boltok = el.querySelector('.wk-szallit__boltok');
      var lista = el.querySelector('.wk-szallit__lista');
      var utana = helyiOra(el.dataset.tz) >= Number(el.dataset.cutoff || 14);
      if (!v) { if (fo) fo.hidden = true; if (boltok) boltok.hidden = true; el.hidden = true; return; }
      var szoveg = (utana && v.o14) ? v.o14 : v.o;
      if (szoveg) szoveg = datumHelyorzok(szoveg, el.dataset.tz, (el.dataset.szunnapok || '').split(','));
      if (szoveg) {
        /* "|" elválasztó = több sor (pl. csomagpont vs házhozszállítás külön ígérete) */
        var reszek = szoveg.split('|').map(function (r) { return r.trim(); }).filter(Boolean);
        sz.textContent = '';
        reszek.forEach(function (resz, i) {
          var sorEl = document.createElement('span');
          sorEl.className = 'wk-szallit__sor' + (i === 0 ? ' wk-szallit__sor--fo' : '');
          sorEl.textContent = resz;
          sz.appendChild(sorEl);
        });
        fo.hidden = false;
      } else fo.hidden = true;
      if (boltok && lista) {
        lista.textContent = '';
        /* azonos címkéjű boltok EGY sorban (user-kérés 2026-08-19: az „azonnal átvehető" csak egyszer) */
        var csoport = {}, sorrend = [];
        (v.b || []).forEach(function (b) {
          var t = (utana && b[2]) ? b[2] : b[1];
          if (!t) return;
          if (!csoport[t]) { csoport[t] = []; sorrend.push(t); }
          csoport[t].push(b[0]);
        });
        /* az „azonnal átvehető" csoport mindig ELÖL (user 2026-08-24), a többi a bolt-sorrendben utána */
        sorrend.sort(function (a, b) {
          return (/azonnal|ihned|ihneď|now/i.test(b) ? 1 : 0) - (/azonnal|ihned|ihneď|now/i.test(a) ? 1 : 0);
        });
        sorrend.forEach(function (t) {
          var li = document.createElement('li');
          var pont = document.createElement('span');
          pont.className = 'wk-szallit__pont' + (/azonnal/i.test(t) ? ' wk-szallit__pont--zold' : '');
          var ert = document.createElement('span'); ert.className = 'wk-szallit__ertek';
          ert.textContent = t.replace(/\.$/, '') + ': ';
          var nev = document.createElement('span'); nev.className = 'wk-szallit__bolt';
          nev.textContent = csoport[t].join(', ');
          li.appendChild(pont); li.appendChild(ert); li.appendChild(nev);
          lista.appendChild(li);
        });
        boltok.hidden = sorrend.length === 0;
      }
      el.hidden = fo.hidden && (!boltok || boltok.hidden);
    }

    frissit(el.dataset.kivalasztott);

    /* a kiválasztott variáns HITELES forrása: a termék-űrlap rejtett id-mezője (a téma minden választónál ezt állítja — rádió, legördülő,
       mobil), tartalék az URL ?variant= paramétere; így a szkript nem függ a választó eseményeitől (user 2026-09-06, iPhone) */
    function aktualisVarians() {
      var inp = document.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('input[name="id"][form]');
      var vid = inp && inp.value;
      if (!vid) { try { vid = new URL(window.location.href).searchParams.get('variant'); } catch (e) { vid = null; } }
      return vid || aktualis;
    }

    if (el.dataset.mod === 'pdp') {
      setInterval(function () { var vid = aktualisVarians(); if (vid && String(vid) !== String(aktualis)) frissit(vid); }, 500);
      if (window.subscribe && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.variantChange) {
        window.subscribe(PUB_SUB_EVENTS.variantChange, function (e) {
          var v = e && e.data && e.data.variant;
          if (v && v.id) frissit(v.id);
        });
      }
      /* tartalék: az URL ?variant= paraméterét is figyeljük variáns-állításkor */
      document.addEventListener('change', function (ev) {
        if (!ev.target.closest) return;
        if (!ev.target.closest('variant-selects, variant-radios, .product-form__input')) return;
        setTimeout(function () { var vid = aktualisVarians(); if (vid) frissit(vid); }, 700);
      });
      /* időzített újraszámolás (cut-off átlépése nyitva hagyott lapon) */
      setInterval(function () { frissit(aktualisVarians()); }, 5 * 60 * 1000);
    }
  }

  function mind() {
    document.querySelectorAll('[data-wk-szallit]').forEach(feldolgoz);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mind);
  else mind();
  new MutationObserver(function () { mind(); }).observe(document.documentElement, { childList: true, subtree: true });
})();
